import api from "@/lib/api/client";

export const notificationApi = {
  list: (params) => api.get("/notifications", { params }).then((r) => ({ items: r.data, meta: r.meta })),
  unreadCount: () => api.get("/notifications/unread-count").then((r) => r.data),
  markRead: (id) => api.post(`/notifications/${id}/read`).then((r) => r.data),
  markAllRead: () => api.post("/notifications/mark-all-read").then((r) => r.data),
};
